import React, { Component } from "react";
import OccasionalMarkingForm from "../OccasionalMarkingForm/OccasionalMarking";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : OccasionalMarkingPage
Description : Componente que invoca al componente OccasionalMarkingForm
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class OccasionalMarkingPage extends Component {
    render() {
        return (
            <OccasionalMarkingForm />
        )
    }
}

export default OccasionalMarkingPage;